module.exports = __webpack_public_path__ + "static/media/39_B.0f478db5.png";